import { styled } from '@/stitches.config';

export const StyledPill = styled('button', {
  background: 'transparent',
  borderRadius: '$pill',
  borderWidth: '0',
  color: '$darkBlue200',
  cursor: 'pointer',
  fontSize: '$md',
  fontWeight: '$bold',
  padding: '$2 $4',
  variants: {
    selected: {
      true: {
        background: '$darkBlue700',
      },
    },
  },
});
